import { defineDeckPassive } from '../authoring/index.js';
export const EnergyReservePassive = defineDeckPassive({
    id: 'energy_reserve',
    role: 'available',
    presentation: {
        name: 'Запас энергии',
        description: 'Вся неизрасходованная энергия переносится в следующий раунд.',
        glyph: {
            colors: ['#10213A', '#9D9C9C', '#F6E8D7', '#F9A647', '#F6BF5C'],
            rows: [
                '....................',
                '........11111.......',
                '........12231.......',
                '....111111111111....',
                '...12222222223331...',
                '...12222222222221...',
                '....121111111121....',
                '....121444444121....',
                '....121544444121....',
                '....121554544121....',
                '....121111111121....',
                '....121555555121....',
                '....121555553121....',
                '....121553353121....',
                '....121111111121....',
                '....121333333121....',
                '....121333333121....',
                '....121111111121....',
                '....122222222221....',
                '....111111111111....',
            ],
        },
    },
    hooks: {
        onAnyEvent(ctx, event) {
            if (ctx.effect?.scope.kind !== 'player'
                || event.type !== 'TemporaryEnergyExpired'
                || event.playerId !== ctx.effect.scope.playerId
                || event.unused <= 0)
                return;
            ctx.ops.grantTemporaryEnergy(event.playerId, event.unused);
        },
        onAfterCombat(ctx) {
            if (ctx.effect?.scope.kind !== 'player')
                return;
            const playerId = ctx.effect.scope.playerId;
            const unspentRegularEnergy = ctx.q.player(playerId).resources.energy;
            if (unspentRegularEnergy > 0) {
                ctx.ops.grantTemporaryEnergy(playerId, unspentRegularEnergy);
            }
        },
    },
});
//# sourceMappingURL=energy_reserve.js.map